import { copy as sharedUiCopy } from '@shared/copy';
import { Skeleton, SkeletonFields } from '@shared/ui/Skeleton';

/**
 * The pending state of `/people/:slug`.
 *
 * The head of this surface is a portrait beside the display name and the role
 * line, so the placeholder opens on a circle rather than on a bar — a credited
 * person is identified by their picture first on every surface that carries one.
 *
 * The credit table below reads separately and draws `RowSkeleton` at its own
 * column count, so nothing here reserves it. Three field rows: the name, the
 * handle and the biography are what the record's form holds.
 */
export function PersonDetailSkeleton() {
  return (
    <>
      <p role="status" className="sr-only">
        {sharedUiCopy.state.loading}
      </p>

      <div
        aria-hidden="true"
        className="mb-6 mt-3 grid gap-4 rounded-md border border-border bg-surface p-4 md:p-5"
      >
        <div className="flex items-center gap-4">
          <Skeleton className="h-[4.5rem] w-[4.5rem] shrink-0 rounded-pill" />
          <div className="grid min-w-0 flex-1 gap-2">
            <Skeleton className="h-8 w-1/2" />
            <Skeleton className="h-4 w-1/3" />
          </div>
        </div>
      </div>

      <SkeletonFields rows={3} />
    </>
  );
}
